module.exports = __webpack_public_path__ + "odinstatic/media/consigner.d065bc68.svg";